export const platformStats = [
  { value: '500万+', label: '累计注册用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '8年', label: '稳定运营' },
  { value: '24/7', label: '全天候客服支持' },
];

export const platformFeatures = [
  {
    icon: 'ri-shield-check-line',
    title: '官方正版认证',
    description: '经权威机构认证的正规平台，拥有完整的运营资质，保障每一位用户的合法权益与资金安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速访问通道',
    description: '采用全球分布式服务器架构，智能路由优化，确保用户随时随地享受流畅无卡顿的访问体验。',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '专属会员权益',
    description: '注册即享多重专属福利，VIP等级体系完善，越活跃权益越丰厚，长期用户更有惊喜回馈。',
  },
  {
    icon: 'ri-lock-line',
    title: '多重安全防护',
    description: '采用银行级数据加密技术，配合智能风控系统，全方位守护您的账户与交易安全。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业客服团队',
    description: '7×24小时在线客服支持，平均响应时间不超过30秒，问题解决率高达98%以上。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    description: '支持PC端、移动端、平板多设备使用，数据实时同步，随时随地畅享服务。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    role: '资深用户 · 使用3年',
    content: '从2019年就开始使用鼎盛平台了，一直很稳定，从来没有出现过任何安全问题。客服响应也很快，强烈推荐！',
    rating: 5,
  },
  {
    name: '李女士',
    role: 'VIP会员 · 使用2年',
    content: '平台的VIP权益真的很丰富，每个月都有专属福利。界面的操作也很简单直观，新手也能快速上手。',
    rating: 5,
  },
  {
    name: '王先生',
    role: '活跃用户 · 使用1年',
    content: '对比了好几个平台，最终还是选择了鼎盛。注册流程简单快捷，而且平台活动很多，体验非常好。',
    rating: 5,
  },
  {
    name: '赵女士',
    role: '新用户 · 使用3个月',
    content: '朋友推荐来的，一开始还有点担心，但用了之后发现真的很靠谱。新用户福利很给力，已经推荐给更多朋友了。',
    rating: 4,
  },
];

export const faqData = [
  {
    question: '52662鼎盛平台是否正规可靠？',
    answer: '52662鼎盛平台是经过国家相关部门认证备案的正规平台，拥有完善的运营资质和安全保障体系。平台运营多年，积累了数百万用户的信任，始终坚持合规经营，保障用户权益。',
  },
  {
    question: '如何注册鼎盛平台账号？',
    answer: '注册流程非常简单：点击页面上的"立即注册"按钮，填写基本信息（手机号/邮箱），设置登录密码，完成短信或邮箱验证即可。整个过程只需1-2分钟，注册后即可享受新用户专属福利。',
  },
  {
    question: '鼎盛平台支持哪些设备？',
    answer: '鼎盛平台支持PC端（Windows/Mac）、移动端（iOS/Android）以及平板设备，所有数据实时云端同步，您可以随时随地切换设备使用，享受一致的服务体验。',
  },
  {
    question: '如何保障账户和资金安全？',
    answer: '我们采用银行级别的SSL加密技术、多重身份验证、智能风控系统和7×24小时安全监控。所有敏感数据均经过加密存储，并定期进行第三方安全审计，全方位守护您的资产安全。',
  },
  {
    question: '遇到问题如何联系客服？',
    answer: '我们提供7×24小时全天候在线客服支持，您可以通过官网在线客服、客服热线400-XXX-XXXX或发送邮件至support@52662dingsheng.com联系我们，平均响应时间不超过30秒。',
  },
];